import React, { useCallback, useMemo } from "react";
import CardContainer from "../../cardContainer";
import FleetOverviewCardContent from "./fleetOverViewCardContent";
import { EmployeeData, VehicleData } from "../../../../models/monitorView/monitorViewTypes";

import { employeeGroupListItemDto } from "../../../../models/employeeGroup/employeeGroup";
import { FlespiVehicleCameraData } from "../../../../models/vehicle/flespiDataTypes";
import { getWorkTimeTypeColorCode } from "../../../../models/workShitTimeSlot/workTimeType";

const defaultCardContentStyles = { padding: 0.5 };

interface FleetOverviewCardProps {
    employee?: EmployeeData;
    employeeGroups: employeeGroupListItemDto[];
    vehicle?: VehicleData;
    isSelected: boolean;
    cameraData?: FlespiVehicleCameraData;
    onSelectVehicle: (vehicleId: string) => void;
    onSelectEmployee: (employeeId: string) => void;
}

const FleetOverviewCard: React.FC<FleetOverviewCardProps> = React.memo(({ employee, employeeGroups, isSelected, vehicle, cameraData, onSelectVehicle, onSelectEmployee }) => {
    const handleCardClick = useCallback(() => {
        if (vehicle?.vehicleId) {
            onSelectVehicle(vehicle.vehicleId);
        } else if (employee?.currentWorkShift && employee?.employeeId) {
            onSelectEmployee(employee.employeeId);
        }
    }, [vehicle?.vehicleId, employee?.currentWorkShift, employee?.employeeId, onSelectVehicle, onSelectEmployee]);

    const handleSelectEmployee = useCallback(() => {
        const employeeId = vehicle?.employeeId ?? employee?.employeeId;
        if (!employeeId) return;
        if (vehicle) {
            onSelectEmployee(employeeId);
        } else if (employee?.currentWorkShift) {
            onSelectEmployee(employeeId);
        }
    }, [vehicle?.employeeId, employee?.employeeId, employee?.currentWorkShift, vehicle, onSelectEmployee]);

    const cardStyles = useMemo(
        () => ({
            borderRadius: "10px",
            marginBottom: 2,
            ...(employee?.workTimeTypeType
                ? {
                    borderLeft: "3px solid",
                    borderColor: `${getWorkTimeTypeColorCode(employee.workTimeTypeType)}`,
                }
                : {}),
        }),
        [employee?.workTimeTypeType]
    );

    return (
        <CardContainer isSelected={isSelected}
            cardStyles={cardStyles}
            cardContentStyles={defaultCardContentStyles}
            onClick={handleCardClick}
        >
            <FleetOverviewCardContent
                vehicle={vehicle}
                employee={employee}
                employeeGroups={employeeGroups}
                cameraData={cameraData}
                onSelectEmployee={handleSelectEmployee}
            />
        </CardContainer>
    );
});

FleetOverviewCard.displayName = "FleetOverviewCard";

export default FleetOverviewCard;